const t=s=>s===""?!0:/^[~`!@#$%^&*()_+=[\]\{}|;':",.\/<>?a-zA-Z0-9-]+$/.test(s);export{t as isOnEnglishKeyboard};
